/// <amd-module name="Wit/WorkItemForm/Links/LinksTab" />
import * as React from "react";
import { useMemo } from "react";
import * as Resources from "Wit/WorkItemForm/Resources";
import { CollapsibleSection } from "../Common/Components";
import { useWorkItem } from "../Common/Hooks";
import { LinksControl } from "./Controls/LinksControl";
import { getDefaultLinkableWorkItemTypeFilter, getDefaultLinkTypeFilter } from "Wit/Common/Utils/WorkItemUtils/LinkTypeFilter";

export function LinksTab() {
    const linkTypeFilter = useDefaultLinkTypeFilter();
    const linkableWorkItemTypeFilter = useDefaultWorkItemTypeFilter();
    return (
        <div className="work-item-form-tab full-width">
            <CollapsibleSection label={Resources.Links}>
                <LinksControl compact={false} linkTypeFilter={linkTypeFilter} linkableWorkItemTypeFilter={linkableWorkItemTypeFilter} 
                showZeroDataExperience={false} />
            </CollapsibleSection>
        </div>
    );
}

function useDefaultLinkTypeFilter() {
    const workItem = useWorkItem();
    const filter = useMemo(() => getDefaultLinkTypeFilter(workItem), [workItem]);
    return filter;
}

function useDefaultWorkItemTypeFilter() {
    const workItem = useWorkItem();
    const filter = useMemo(() => getDefaultLinkableWorkItemTypeFilter([workItem]), [workItem]);
    return filter;
}
